import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import Body from './Body'
import { useEeocContext } from '../useEeoc'

interface VoidModalProps {
  id: string
}

const VoidModal: React.FC<VoidModalProps> = (props) => {
  const { id } = props
  const { modals } = useEeocContext()

  return (
    <Modal
      title='Void EEOC Paperwork'
      isOpen={modals.void.isOpen}
      toggle={modals.void.toggle}
    >
      <Header title='Void EEOC Paperwork' />
      <Body id={id} />
    </Modal>
  )
}

export default VoidModal
